import { SensorObject } from './../../../../../../app/asp/SensorObject';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { VideoPlayerWindowComponent } from './video-player-window.component';

@Injectable({
  providedIn: 'root'
})

export class VideoPlayerService {
  private dialogRef: MatDialogRef<any>;
  private dialogRefArr: MatDialogRef<any>[] = [];
  public SetcountOpenVideo : number;
  constructor(private dialog: MatDialog) { 
  }



  async showVideoPlayer(sensor: SensorObject) {
    // this.dialogRef = this.getFromArr(sensor.sensorID);
    // if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
    //   (this.dialogRef.componentInstance as any).dialogRaise();
    // }
    // else {
      let videoPlayerComp;
      // if (environment.name.toLowerCase() == 'dev') { // we are in dev mode...
      //   let dialogConfig = await VideoPlayerComponent.createDialogConfig('assets/example.mp4') as MatDialogConfig;
      //   this.dialogRef = this.dialog.open(VideoPlayerComponent, dialogConfig);
      //   this.dialogRefArr.push(this.dialogRef);
      //   videoPlayerComp = this.dialogRef.componentInstance as VideoPlayerComponent;
      //   videoPlayerComp.dialogRaise();
      // }
      // else { // we are in production...
        this.dialogRef = this.dialog.open(VideoPlayerWindowComponent, VideoPlayerWindowComponent.createDialogConfig(sensor));
        this.dialogRefArr.push(this.dialogRef);
        videoPlayerComp = this.dialogRef.componentInstance as VideoPlayerWindowComponent;
        videoPlayerComp.setSensor(sensor);
        videoPlayerComp.dialogRaise();
      // }
    // }
  }

  getFromArr(num: number): any {
    let Ref: MatDialogRef<any> = null;
    this.removeGarbage();
    this.dialogRefArr.forEach((ref) => {
      let refSensorAro = ref.componentInstance as VideoPlayerWindowComponent;
      if (refSensorAro) {
        if (num == refSensorAro.sensorID) {
          Ref = ref;
          return;
        }
      }
    })
    return Ref;
  }
  
  closeAllDialogs(): any {
    this.removeGarbage();
    this.dialogRefArr.forEach((ref) => {
      const refSensorAro = ref.componentInstance as VideoPlayerWindowComponent;
      refSensorAro?.dialogRef.close()
    });
  }

  removeGarbage() {
    this.dialogRefArr = this.dialogRefArr.filter(ele => {
      return (ele != null && ele !== undefined && ele.getState() != MatDialogState.CLOSED);
    })
  }
}
